import React from 'react';
import { AuthUser } from '../types/auth';

interface TopStripProps {
  currentView: 'chat' | 'management' | 'superadmin' | 'dashboards';
  onViewChange: (view: 'chat' | 'management' | 'superadmin' | 'dashboards') => void;
  user?: AuthUser | null;
  onLogout?: () => void;
  warnungenAnzahl?: number;
  onWarnungenClick?: () => void;
  onSettingsClick?: () => void;
  mood?: string;
  onMoodToggle?: () => void;
}

const MOOD_LABEL: Record<string, string> = { hell: 'Hell', dunkel: 'Dunkel', mix: 'Mix' };

const TopStrip: React.FC<TopStripProps> = ({
  currentView, onViewChange, user, onLogout,
  warnungenAnzahl = 0, onWarnungenClick, onSettingsClick,
  mood = 'hell', onMoodToggle,
}) => {
  return (
    <header className="k-strip">
      <div className="k-strip__left">
        <span className="k-strip__dot"></span>
        <span className="k-strip__brand">Kontor</span>
        <span className="k-strip__sep k-strip__product">·</span>
        <span className="k-strip__product">Agentisches ERP</span>
        {user?.rolle === 'SuperAdmin' ? (
          <>
            <span className="k-strip__sep">·</span>
            <span className="k-strip__mandant">Plattform-Admin</span>
          </>
        ) : user?.firmenname ? (
          <>
            <span className="k-strip__sep">·</span>
            <span className="k-strip__mandant">Mandant: {user.firmenname}</span>
          </>
        ) : null}
      </div>

      <nav className="k-strip__nav">
        <button
          className={'k-strip__navbtn' + (currentView === 'chat' ? ' is-active' : '')}
          onClick={() => onViewChange('chat')}
        >
          Agent
        </button>
        <button
          className={'k-strip__navbtn' + (currentView === 'dashboards' ? ' is-active' : '')}
          onClick={() => onViewChange('dashboards')}
        >
          Dashboards
        </button>
        <button
          className={'k-strip__navbtn' + (currentView === 'management' ? ' is-active' : '')}
          onClick={() => onViewChange('management')}
        >
          Verwaltung
        </button>
        {user?.rolle === 'SuperAdmin' && (
          <button
            className={'k-strip__navbtn' + (currentView === 'superadmin' ? ' is-active' : '')}
            onClick={() => onViewChange('superadmin')}
          >
            Admin
          </button>
        )}
      </nav>

      <div className="k-strip__right">
        <span className="k-strip__claim">DSGVO by default — Made in Germany</span>
        {onMoodToggle && (
          <button className="k-strip__btn" onClick={onMoodToggle} title="Stimmung wechseln (Hell / Dunkel / Mix)">
            {MOOD_LABEL[mood] ?? 'Hell'}
          </button>
        )}
        {user && (
          <button
            className={'k-strip__btn' + (warnungenAnzahl > 0 ? ' has-signal' : '')}
            onClick={onWarnungenClick}
            title={`${warnungenAnzahl} ungelesene Warnung(en)`}
          >
            Warnungen{warnungenAnzahl > 0 && (
              <span className="k-strip__count">{warnungenAnzahl > 99 ? '99+' : warnungenAnzahl}</span>
            )}
          </button>
        )}
        {user && ['Admin', 'Geschäftsführer', 'SuperAdmin'].includes(user.rolle) && (
          <button className="k-strip__btn" onClick={onSettingsClick} title="Einstellungen">
            Einstellungen
          </button>
        )}
        {user && (
          <span className="k-strip__user" title={user.email}>
            {user.name} <span className="k-strip__sep">/</span> {user.rolle}
          </span>
        )}
        {user && onLogout && (
          <button className="k-strip__btn" onClick={onLogout}>
            Abmelden
          </button>
        )}
      </div>
    </header>
  );
};

export default TopStrip;
